import { a } from './chunk-IMSWER4T.js';

var r=class{async searchProductVariants({page:s=1,limit:a$1=15,query:t="",sortBy:o=""}){return (await a.instance.get(`/product-variants?page=${s}&limit=${a$1}${t!==""?"&query="+t:""}${o!==""?"&sortBy="+o:""}`)).data}};

export { r as a };
//# sourceMappingURL=chunk-UN2EEWOO.js.map
//# sourceMappingURL=chunk-UN2EEWOO.js.map